import PropTypes from "prop-types";
import React from "react";
import "./ToolTip.css";

const ToolTip = (props) => {
  const { message, position, displayTooltip } = props;
  return (
    <>
      {displayTooltip ? (
        <div className={`tooltip-bubble tooltip-${position}`}>
          <div className="tooltip-message">{message}</div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

ToolTip.propTypes = {
  message: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  displayTooltip: PropTypes.bool.isRequired,
};

export default ToolTip;
